import React, { useState } from 'react';
import { useMutation } from 'react-query';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import { RiEyeFill, RiEyeOffFill } from 'react-icons/ri';
import FormHelperText from '@mui/material/FormHelperText';

import { createUser } from '../../api/admin';
import { useNotification } from '../../context/notification';

function Users() {
  const [formData, setFormData] = useState({
    admin: false,
    promo: false,
    event: false,
    en: false,
    fr: false,
    ar: false,
    es: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const { addNotification } = useNotification();

  const { mutate: create, isLoading: updateIsLoading } = useMutation((data) => createUser(data), {
    onSuccess: (data) => {
      addNotification({ message: data.message });
    },
    onError: (err) => {
      addNotification({ message: `Une erreur est survenue: ${err.message}`, severity: 'error' });
    },
  });

  const rights = [
    { label: 'Admin', value: 'admin' },
    { label: 'Promo', value: 'promo' },
    { label: 'EVENT', value: 'event' },
    { label: 'Thème', value: 'theme' },
    { label: 'Français', value: 'fr' },
    { label: 'Anglais', value: 'en' },
    { label: 'Arabe', value: 'ar' },
    { label: 'Espagnol', value: 'es' },
  ];

  return (
    <section className="flex items-center justify-center flex-wrap space-x-6 authForm">
      <div className="bg-black p-8 space-y-4 rounded" style={{ maxWidth: '343px' }}>
        <FormControl fullWidth variant="standard">
          <InputLabel>Nom d&apos;utilisateur</InputLabel>
          <Input
            autoComplete="off"
            type="text"
            onChange={(e) => setFormData((prev) => ({ ...prev, username: e.target.value }))}
            size="small"
            value={formData.username}
          />
        </FormControl>
        <FormControl fullWidth variant="standard" error={formData.error}>
          <InputLabel>Mot de passe</InputLabel>
          <Input
            autoComplete="off"
            id="standard-adornment-password"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) =>
              setFormData((prev) => {
                const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
                if (strongRegex.test(e.target.value)) {
                  return { ...prev, password: e.target.value, error: false };
                }
                return { ...prev, error: true, password: e.target.value };
              })
            }
            size="small"
            value={formData.password}
            endAdornment={
              <button
                type="button"
                className="focus"
                aria-label="toggle password visibility"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <RiEyeOffFill color="white" /> : <RiEyeFill color="white" />}
              </button>
            }
          />
          {formData.error && (
            <FormHelperText>
              Le mot de passe doit contenir: minuscule, majuscule, chiffre, caractère spécial, 8 caractères minimums.
            </FormHelperText>
          )}
        </FormControl>

        <div className="flex flex-col userRights">
          {rights.map((lang) => (
            <FormControlLabel
              key={`right_${lang.value}`}
              control={
                <Checkbox
                  size="small"
                  onChange={(e) => setFormData((prev) => ({ ...prev, [lang.value]: e.target.checked }))}
                  sx={{ padding: '0 0.5rem' }}
                />
              }
              label={lang.label}
            />
          ))}
        </div>
        <button
          type="button"
          onClick={() => {
            if (formData.error) {
              return addNotification({
                message:
                  'Le mot de passe doit contenir: minuscule, majuscule, chiffre, caractère spécial, 8 caractères minimums.',
                severity: 'error',
              });
            }
            create(formData);
          }}
          className="px-4 py-2 mt-8 rounded bg-zinc-900 hover:bg-blue-500 duration-500 disabled:opacity-50 disabled:hover:bg-zinc-900"
        >
          {updateIsLoading ? <CircularProgress size={13} /> : 'Valider'}
        </button>
      </div>
    </section>
  );
}

Users.propTypes = {};

export default Users;
